import { Application } from "@core/Application";
import { NovedadesAuditLog } from "@services/NovedadesService";
import { useCallback, useEffect, useState } from "react";

interface UseConfiguracionNovedadesAuditoriaViewModelArgs {
    orgID: string;
}

export function useConfiguracionNovedadesAuditoriaViewModel({
    orgID,
}: UseConfiguracionNovedadesAuditoriaViewModelArgs) {
    const [auditData, setAuditData] = useState<NovedadesAuditLog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [selectedAuditLog, setSelectedAuditLog] = useState<NovedadesAuditLog | null>(null);

    const fetchAuditLogs = useCallback(async () => {
        if (!orgID) {
            setAuditData([]);
            setLoading(false);
            setError(null);
            setSelectedAuditLog(null);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const novedadesService = Application.shared().coreDependencies.novedadesService;
            const result = await novedadesService.getAuditLogs(orgID);
            setAuditData(result);
        } catch (error) {
            console.error("Error fetching novedades audit logs:", error);
            setAuditData([]);
            setError("No se pudo cargar la auditoría de novedades.".localized());
        } finally {
            setLoading(false);
        }
    }, [orgID]);

    useEffect(() => {
        void fetchAuditLogs();
    }, [fetchAuditLogs]);

    return {
        auditData,
        loading,
        error,
        selectedAuditLog,
        openDetail: setSelectedAuditLog,
        closeDetail: () => setSelectedAuditLog(null),
    };
}
